import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { mSecondsFromEpoch } from 'src/app/types/@types/sl-v-types';
import { SearchCriterion, CriterionEvent, ICriterionComponent, SearchCriteriaRegistrant } from 'src/app/types/search-criteria';

import { formatDate } from '@angular/common';

@Component({
  selector: 'app-date-val',
  templateUrl: './date-val.component.html',
  styleUrls: ['./date-val.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateValComponent implements OnInit, ICriterionComponent {

  public dateValue: string = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  @Input()
  public field = '';
  @Output()
  public registrantReady = new EventEmitter<SearchCriteriaRegistrant>();
  @Input()
  public comparison = '';

  @Output() criteriaChange = new EventEmitter<CriterionEvent>();

  @Input()
  get value(): string {
    return this.dateValue;
  }
  set value(val: string) {
    this.dateValue = val;
    this.cdr.detectChanges();
  }
  @Output() valueChange = new EventEmitter<string>();

  @ViewChild('dateInput') dateInput: ElementRef<HTMLInputElement>;

  HandleDateChange() {
    // this.dateValue = formatDate(new Date(this.dateInput.nativeElement.value),'yyyy-MM-dd','en');
    if (!!this.dateValue) {
      this.valueChange.emit(this.dateValue);
    }
    this.criteriaChange.emit({
      target: this,
      value: this.value,
      criterion: this.ToCriterion()
    });

  }
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.dateValue = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.registrantReady.emit({ field: this.field, component: this })
  }

  ToCriterion(field?: string, comparison?: string): SearchCriterion | null {
    if (!field) {
      field = this.field;
      if (field === '') {
        return null;
      }
    }
    if (!comparison) {
      comparison = this.comparison;
      if (comparison === '') {
        return null;
      }
    }

    return {
      compare: (comparison),
      field: (field),
      value: this.value,
      casting: 'date'
    }
  }



}
